import BaseIcon from "./base"

/**
 * Icon SIEnergy from 'react-icons/si'.
 */
export default function EnergyIcon({size = 24}) {
    return (
        <BaseIcon size={size}>
            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><polygon fill="none" strokeWidth="2" points="4 14 10 14 7 23 9 23 20 9 14 9 18 1 7 1"></polygon></svg>
        </BaseIcon>
    )
}
